var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsLevelUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "direct-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.11333 3.14L2.04667 10.8667C1.08 12.7 3.03333 14.6933 4.88667 13.7667L7.04667 12.6867C7.64667 12.3867 8.35333 12.3867 8.95333 12.6867L11.1133 13.7667C12.9667 14.6933 14.9133 12.7 13.9533 10.8667L9.88667 3.14C9.08667 1.62 6.91333 1.62 6.11333 3.14Z",
    stroke: "#228773",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0,
    d: "M0.75 15.25L0.75 0.75L15.25 0.75L15.25 15.25L0.75 15.25Z",
    stroke: "#228773",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsLevelUp);
export default __webpack_public_path__ + "static/media/rewards-level-up.dfb54bc55218f00e4686f60d22e5d6f7.svg";
export { ForwardRef as ReactComponent };